import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AllFormsComponent } from './admin/all-forms/all-forms.component';
import { HeaderComponent } from './shared/header/header.component';
import { SideNavComponent } from './shared/side-nav/side-nav.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ViewFormComponent } from './admin/view-form/view-form.component';
import { ViewSubmissionsComponent } from './admin/view-submissions/view-submissions.component';
import { FreetextSearchPipe } from './admin/filters/freetext-search.pipe';
import { FormsModule } from '@angular/forms';
import { AssignmentComponent } from './admin/assignment/assignment.component';
import {ReactiveFormsModule} from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AddUsersComponent } from './admin/add-users/add-users.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FacilitiesComponent } from './admin/facilities/facilities.component';
import { ErrorMessageComponent } from './shared/error-message/error-message.component';
import { ProgressIndicatorComponent } from './shared/progress-indicator/progress-indicator.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ManageGroupMembersComponent } from './admin/manage-group-members/manage-group-members.component';


@NgModule({
  declarations: [
    AppComponent,
    AllFormsComponent,
    HeaderComponent,
    SideNavComponent,
    DashboardComponent,
    FooterComponent,
    ViewFormComponent,
    ViewSubmissionsComponent,
    FreetextSearchPipe,
    AssignmentComponent,
    AddUsersComponent,
    FacilitiesComponent,
    ErrorMessageComponent,
    ProgressIndicatorComponent,
    ManageGroupMembersComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatButtonToggleModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
